/**
 * Set once, right after a brand-new account is created (`authStore.signup`) — sessionStorage
 * rather than React prop/state, specifically so it survives the redirect straight into the
 * signed-in app that follows signup (a fresh `AppShell`/`TutorialButton` mount would otherwise
 * have no way to know "this session's profile is the one that was JUST created" by the time it
 * renders). Consumed exactly once, by `TutorialButton` on mount, to force the welcome
 * walkthrough open regardless of the per-browser "seen" flag or the durable dismissed pref —
 * neither can possibly be meaningfully true yet for an account that's seconds old.
 *
 * Lives here rather than in `TutorialButton.tsx` itself so `authStore.ts` (where the signup
 * action lives) doesn't need to import a UI component to set it.
 */
const JUST_SIGNED_UP_KEY = 'crickethub.tutorial.justSignedUp'

export function markJustSignedUp(): void {
  try {
    sessionStorage.setItem(JUST_SIGNED_UP_KEY, '1')
  } catch {
    /* ignore — worst case a brand-new user just doesn't get the auto-open this once */
  }
}

export function consumeJustSignedUp(): boolean {
  try {
    const v = sessionStorage.getItem(JUST_SIGNED_UP_KEY) === '1'
    if (v) sessionStorage.removeItem(JUST_SIGNED_UP_KEY)
    return v
  } catch {
    return false
  }
}
